const toDMS = (value: number): string => {
  const abs = Math.abs(value);
  const degrees = Math.floor(abs);
  const minFloat = (abs - degrees) * 60;
  const minutes = Math.floor(minFloat);
  const seconds = ((minFloat - minutes) * 60).toFixed(1);
  return `${degrees}\u00B0${String(minutes).padStart(2, '0')}'${seconds}"`;
};

export const formatLatitudeDMS = (latitude: number | null | undefined): string => {
  if (latitude == null || !Number.isFinite(latitude)) return '';
  const dir = latitude >= 0 ? 'N' : 'S';
  return `${toDMS(latitude)}${dir}`;
};

export const formatLongitudeDMS = (longitude: number | null | undefined): string => {
  if (longitude == null || !Number.isFinite(longitude)) return '';
  const dir = longitude >= 0 ? 'E' : 'W';
  return `${toDMS(longitude)}${dir}`;
};

export const formatCoordinateDMS = (
  latitude: number | undefined,
  longitude: number | undefined,
): string => {
  if (latitude == null || longitude == null) return '';
  return `${formatLatitudeDMS(latitude)} ${formatLongitudeDMS(longitude)}`;
};
